// export const SCOUT_API = 'https://scout-api-1012168475022.us-central1.run.app'
// export const SCOUT_API = 'http://127.0.0.1:5000'
export const SCOUT_API = 'https://scout-api-dev-1012168475022.us-central1.run.app'

export const PPI_API = "https://ppi-api-testv-1-1012168475022.us-central1.run.app";
// test api
// export const PPI_API = 'https://ppi-api-paywall-demo-1012168475022.us-central1.run.app';
//export const PPI_API = 'http://127.0.0.1:5001'